import { Flex, Spinner } from '@chakra-ui/react';
import SkeletonTable from './states/SkeletonTable';

type Props = {
    isLoading: boolean;
    /** 'table' shows a shimmer skeleton matching table structure (default).
     *  'spinner' shows the legacy centered spinner — use for refresh indicators. */
    variant?: 'table' | 'spinner';
    rows?: number;
    columns?: number;
}

export default function Loader({ isLoading, variant = 'table', rows, columns }: Props) {
    if (!isLoading) return null;

    if (variant === 'table') {
        return <SkeletonTable rows={rows} columns={columns} />;
    }

    return (
        <Flex flex={1} justifyContent={'center'} alignItems={'center'}>
            <Spinner size='xl' color='brand.500' />
        </Flex>
    )
}
